(() => {
  'use strict';
  const BOX_HANDLES = ['boite-decouverte', 'boite-grande', 'boite-garde-manger', 'decouverte', 'grande', 'garde-manger'];
  const ADDON_HINTS = ['sac-lyopup', 'gateries', 'addon-'];

  const normId = (id) => {
    const s = String(id ?? '');
    const digits = s.match(/(\d{8,})/);
    return digits ? digits[1] : s;
  };

  function catalog() {
    try {
      return window.LyoShopify?.catalog || JSON.parse(document.getElementById('lyopup-config')?.textContent || '{}').catalog || {};
    } catch {
      return {};
    }
  }

  function isRawAddon(item) {
    if (!item) return false;
    if (String(item.properties?._lyopup_launch_gift || '') === 'true') return false;
    const handle = String(item.handle || '').toLowerCase();
    if (ADDON_HINTS.some((h) => handle.includes(h))) return true;
    const props = item.properties || {};
    if (props._lyopup_mix || props.Composition) return false;
    const cat = catalog();
    const addonIds = ['addon-sweet', 'addon-carrot', 'addon-bean']
      .map((k) => normId(cat[k]?.variantId))
      .filter(Boolean);
    if (addonIds.includes(normId(item.variant_id || item.id))) return true;
    const price = item.final_price != null ? item.final_price / 100 : Number(item.price);
    return Math.abs(price - 13.99) < 0.001;
  }

  function isRawBox(item) {
    if (!item) return false;
    const handle = String(item.handle || '').toLowerCase();
    if (BOX_HANDLES.some((h) => handle === h || handle.includes('boite'))) return true;
    const props = item.properties || {};
    if (props._lyopup_mix || props.Composition) return true;
    const cat = catalog();
    const boxIds = ['decouverte', 'grande', 'garde-manger']
      .map((k) => normId(cat[k]?.variantId))
      .filter(Boolean);
    return boxIds.includes(normId(item.variant_id || item.id));
  }

  function lockMessage() {
    const lang = window.LyoShopify?.config?.lang || document.documentElement.lang || 'fr';
    return String(lang).startsWith('en')
      ? 'Remove the add-on bag before removing the box.'
      : 'Supprime d’abord le sac seul avant de retirer la boîte.';
  }

  async function readCart() {
    const root = window.LyoShopify?.config?.root || '/';
    const res = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    return res.json();
  }

  async function assertSafeToRemove(lineKey, quantity) {
    if (Number(quantity) > 0) return;
    const cart = await readCart();
    const target = (cart.items || []).find((item) => item.key === lineKey || String(item.id) === String(lineKey));
    if (!target) return;
    const hasAddon = (cart.items || []).some(isRawAddon);
    if (hasAddon && isRawBox(target)) {
      const err = new Error(lockMessage());
      err.lyoCartLock = true;
      throw err;
    }
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = async function (input, init) {
    const url = String(typeof input === 'string' ? input : input?.url || '');
    if (url.includes('/cart/change') && init?.body) {
      try {
        const body = typeof init.body === 'string' ? JSON.parse(init.body) : init.body;
        await assertSafeToRemove(body.id ?? body.line, body.quantity);
      } catch (error) {
        if (error?.lyoCartLock) {
          try { window.dispatchEvent(new CustomEvent('lyo:cart-lock', { detail: { message: error.message } })); } catch {}
          alert(error.message);
          throw error;
        }
      }
    }
    return originalFetch(input, init);
  };

  // Mark the guard as active for debugging.
  window.LyoCartGuard = { version: 'v4', assertSafeToRemove, isRawAddon, isRawBox };
})();
